import React from "react";
import LogoBig from "../../assets/LogoBig";
import Login from ".";

export default function LoginBox({ vendor } = {}) {

	return <div className="login-box">
		<div className="intro">
			<span className="normalFont">Be more</span>
			<LogoBig crossColor={vendor ? vendor.featureColor1 : undefined} />
		</div>
		<br />
		<Login />
	</div>
}